<div class="app-page-title">
    <div class="page-title-wrapper">
        <div>
            <img src="./assets/images/u2.png" alt="img" width="50px" />
            <span class="page-title-text">Renewal</span>
        </div>
    </div>
</div>

<div class="main-card mb-3 card custom-card">
    <div class="card-body">
        <form [formGroup]="renewalForm">
            <div class="row">
                <div class="col-md-8">
                    <div class="form-group">
                        <label class="label">First Name</label>
                        <input type="text" class="form-control raveens"
                            formControlName="first_name" readonly />
                    </div>

                    <div class="form-group">
                        <label class="label">Last Name</label>
                        <input type="text" class="form-control raveens"
                            formControlName="last_name" readonly />
                    </div>

                    <div class="form-group">
                        <label class="label">Phone Number</label>
                        <input formControlName="phone_number" type="text"
                            class="form-control raveens" readonly />
                    </div>

                    <div class="form-group">
                        <label class="label">Account State</label>
                        <input formControlName="account_state" type="text"
                            class="form-control raveens" readonly />
                    </div>

                    <div class="form-group">
                        <label class="label">Plan Name</label>
                        <input formControlName="plan_name" type="text"
                            class="form-control raveens" readonly />
                    </div>

                    <div class="row mt-3 justify-between">
                        <div class="col-lg-4 mb-3">
                            <div class="main-card card expiry-card">
                                <div class="card-body">
                                    <p class="expiry-label">Validity Days:
                                        {{nextdate}}</p>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-sm-12 col-lg-4 mb-3">
              <div class="main-card card invoice-card">
                <div class="card-body">
                  <p class="invoice-label">Invoice Amount: ₹{{totalAmount}}</p>
                </div>
              </div>
            </div> -->

                    </div>

                    <div class="mt-4">
                        <img src="./assets/images/pay.jpg" alt="pay1"
                            class="payment-image" />
                    </div>

                    <div class="card-footer">
                        <button type="button"
                            class="mb-2 me-2 btn btn-primary"
                            (click)="paymentSubmit()"
                            [disabled]="renewalForm.get('account_state')?.value !== 'expired'"
                            [ngStyle]="{'cursor': renewalForm.get('account_state')?.value !== 'expired' ? 'no-drop' : 'pointer'}"> Submit </button>
                        <button type="button" class="mb-2 me-2 btn btn-light"
                            (click)="cancel()">Cancel</button>
                    </div>

                </div>

                <div class="col-md-4">
                    <div class="invoice invoice-breakup">
                        <h3 class="fw-bold">Invoice Amount Breakups</h3>
                        <p class="invoice-list"><span class="label">Base
                                Price:</span><span class="invoice-cont">{{
                                base_price }}</span></p>
                        <p class="invoice-list"><span class="label">Per Tax
                                Price:</span><span class="invoice-cont">{{
                                pre_tax_price }}</span></p>
                        <p class="invoice-list"><span class="label">Default
                                Discount:</span><span
                                class="invoice-cont">{{discout_price}}</span></p>
                        <p class="invoice-list"><span class="label">Additional
                                Discount:</span><span
                                class="invoice-cont">{{disc_price_2_txt}}</span></p>
                        <p class="invoice-list"><span
                                class="label">Tax:</span><span
                                class="invoice-cont">{{tax_price}}</span></p>
                        <hr />
                        <p class="invoice-list"><span class="label">Plan
                                Price:</span><span class="invoice-cont">{{
                                plan_price }}</span></p>
                        <p class="invoice-list"><span class="label">Total Amount
                                Need to Pay:</span><span class="invoice-cont">{{
                                total_price }}</span></p>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
